import { useQuery } from 'react-query'
import { toast } from 'react-toastify'
import { axios } from 'lib'
import { PaginatedParams, PaginatedResponse } from 'services/api/types'

type Params = PaginatedParams & {
  sellerId?: string
}

const loadOrdersCustomers = (params: Params): PaginatedResponse<any> => {
  return axios.get('/orders/customers', {
    params
  })
}

export function useLoadOrdersCustomers(params: Params) {
  return useQuery(
    ['ordersCustomers', params],
    () => loadOrdersCustomers(params),
    {
      keepPreviousData: true,
      enabled: !!params?.sellerId,
      onError: () =>
        toast.error('Não foi possível carregar clientes', {
          toastId: 'loadOrdersCustomers'
        })
    }
  )
}
